import React from 'react';
import { Link } from 'react-router-dom';

const GradientButton = ({
  onClick,
  text,
  width,
  height,
  icon,
  padding,
  navigateTo,
  rounded = 'rounded-md',
}) => {
  const buttonClasses = `${width} ${height} ${padding}  2xl:[22px] bg-gradient-to-r from-[#C572A7] to-[#7F76AF] hover:from-[#D78AB6] hover:to-[#9A93C7] py-[6px] px-4 text-white ${rounded} font-semibold transition-all duration-300 transform hover:scale-105 text-[16px] sm:text-[20px] inline-flex items-center justify-center`;

  // If navigateTo is provided and it's an internal link, use Link
  if (navigateTo && !navigateTo.startsWith('http')) {
    return (
      <Link to={navigateTo} className={buttonClasses}>
        {icon && (
          <img src={icon} alt="icon" className="w-8 h-8 object-contain mt-1" />
        )}
        {text}
      </Link>
    );
  }

  // For external links or onClick handlers, use button
  const handleClick = () => {
    if (navigateTo?.startsWith('http')) {
      window.open(navigateTo, '_blank');
    } else if (onClick) {
      onClick();
    }
  };

  return (
    <button className={buttonClasses} onClick={handleClick}>
      {icon && (
        <img src={icon} alt="icon" className="w-8 h-8 object-contain mt-1" />
      )}
      {text}
    </button>
  );
};

export default GradientButton;
